import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { registerServiceWorker, setupInstallPrompt } from './utils/pwaInstaller'
import { initCacheManager } from './utils/cacheManager'

// Initialize cache manager first (clears old versions)
initCacheManager()

// Register Service Worker for PWA/APK
registerServiceWorker()
setupInstallPrompt()

createRoot(document.getElementById('root')!).render(
  <App />,
)
